import CrudGenerator from 'admin/pages/shared/CrudGenerator/CrudGenerator';
import { columns, formSchema } from './MongoQueriesConfig';
import { NewMongoQueryDetails } from './MongoQueriesDetails';
import MongoQueriesService from './MongoQueriesService';
import './style.scss';

export default CrudGenerator({
    columns,
    formSchema,
    defaultNewEntity: { collection: "User", method: "find", filter: {}, projects: {}, sort: {} },
    route: '/admin/mongo-queries',
    entityName: {
        entityNamePlural: "Mongo Queries",
        entityNameSingular: "Mongo Query"
    },
    createEntity: MongoQueriesService.createMongoQuery,
    getEntities: MongoQueriesService.getMongoQueries,
    editEntity: MongoQueriesService.editMongoQueries,
    deleteEntities: MongoQueriesService.deleteMongoQueries,
    modalDetails: NewMongoQueryDetails,
    newModalDetails: NewMongoQueryDetails,
    defaultShowAddEditExpandButton: false,
})